import { useState } from 'react';
import { Selection } from '@quero-delivery/quero-components-web';
import Tooltip from 'rc-tooltip';
import type { Place } from '@/_types/places';
import styles from './post-paid-toggle.module.scss';
import { ActivePostPaidModal } from '@/_features/post-paid/subfeatures/active-post-paid-modal/active-post-paid-modal';
import { DeactivatePostPaidModal } from '../../subfeatures/deactivate-post-paid-modal/deactivate-post-paid-modal';
import { ConfirmActivatePostPaidModal } from '../../subfeatures/confirm-activate-post-paid-modal/confirm-activate-post-paid-modal';
import { useAppSelector } from '@/_store/hooks';
import { selectUser } from '@/_store/modules/auth/selectors';
import { ROLE_TYPES } from '@/Interfaces/Data';

interface PostPaidToggleProps {
  place: Place;
  canActivePostPaidToggle: boolean;
}

export const PostPaidToggle = ({
  place,
  canActivePostPaidToggle,
}: PostPaidToggleProps) => {
  const [isActivateModalVisible, setIsActivateModalVisible] = useState(false);
  const [isConfirmActivateModalVisible, setIsConfirmActivateModalVisible] =
    useState(false);
  const [isDeactivateModalVisible, setIsDeactivateModalVisible] =
    useState(false);

  const user = useAppSelector(selectUser);

  const isPostPaidActive = place?.postPaid?.statusPostPaid === 'ACTIVE';
  const hasPostPaidLimit = (place?.postPaid?.postPaidLimit || 0) > 0;

  const isLogisticOperator =
    user?.managerLogType === ROLE_TYPES.LOGISTIC_OPERATOR;

  const isToggleDisabled = !place?.isActiveOnlinePayment;

  const getTooltipMessage = () => {
    if (place?.isActiveOnlinePayment === false) {
      return 'Precisa de pagamento online';
    }
    if (place?.isActiveOnlinePayment === undefined) {
      return 'Não está disponível';
    }
    return '';
  };

  const handlePostPaidToggle = () => {
    if (!place) return;

    if (isPostPaidActive) {
      setIsDeactivateModalVisible(true);
      return;
    }

    if (hasPostPaidLimit) {
      setIsConfirmActivateModalVisible(true);
      return;
    }

    setIsActivateModalVisible(true);
  };

  const handleCloseActivateModal = () => {
    setIsActivateModalVisible(false);
  };

  const handleCloseConfirmActivateModal = () => {
    setIsConfirmActivateModalVisible(false);
  };

  const handleCloseDeactivateModal = () => {
    setIsDeactivateModalVisible(false);
  };

  if (!canActivePostPaidToggle) {
    return null;
  }

  return (
    <>
      {!isLogisticOperator && (
        <div className={styles.postPaidToggle}>
          <Tooltip
            overlay={<span>{getTooltipMessage()}</span>}
            placement="top"
            visible={isToggleDisabled ? undefined : false}
          >
            <span>
              <Selection
                disabled={isToggleDisabled}
                checked={isPostPaidActive}
                onClick={handlePostPaidToggle}
                type="switch"
                className="switch-with-colors"
              />
            </span>
          </Tooltip>
          <b>Pós pago</b>
        </div>
      )}

      <ActivePostPaidModal
        open={isActivateModalVisible}
        onClose={handleCloseActivateModal}
        placeId={place?._id || ''}
      />

      <ConfirmActivatePostPaidModal
        open={isConfirmActivateModalVisible}
        onClose={handleCloseConfirmActivateModal}
        placeId={place?._id || ''}
      />

      <DeactivatePostPaidModal
        open={isDeactivateModalVisible}
        onClose={handleCloseDeactivateModal}
        placeId={place?._id || ''}
      />
    </>
  );
};
